// The University of New Mexico's undergraduate majors (#2744). Read on
// 2026-10-01 from the official UNM 2026-2027 Catalog (catalog.unm.edu, the
// Registrar's Kuali catalog; the program list and each program's record were
// read through the catalog's own public API, catalog 68a34618094c97cf857f1ec1).
// Every program whose degree type is a bachelor's is kept, grouped by the
// college or school the catalog assigns it; certificates, shared-credit and
// dual-degree entries and graduate programs are left out. The catalog splits
// Arts and Sciences into three divisions; they are one group here. Degree
// abbreviations are the prefix of each program's catalog code (BA, BS, BFA,
// BM, BME, BBA, BLA); the education degrees the catalog names "Bachelor of
// Science in Education" and "Bachelor of Arts in Education" read "BS in
// Education" and "BA in Education". The nursing names are the catalog's own.
// The KB's majors list was the starting point; the catalog wins.
const majors = {
    "slug": "university-of-new-mexico",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree program in UNM's official 2026-2027 Catalog, grouped by the college or school that offers it, with the degree it leads to. Minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Arts and Sciences",
            "source": {
                "label": "UNM 2026-2027 Catalog, Programs",
                "url": "https://catalog.unm.edu/#/programs"
            },
            "majors": [
                {
                    "name": "Africana Studies",
                    "degree": "BA"
                },
                {
                    "name": "American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BS"
                },
                {
                    "name": "Astrophysics",
                    "degree": "BS"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BA"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Biology",
                    "degree": "BA"
                },
                {
                    "name": "Biology",
                    "degree": "BS"
                },
                {
                    "name": "Chemical Biology",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Chicana and Chicano Studies",
                    "degree": "BA"
                },
                {
                    "name": "Classical Studies",
                    "degree": "BA"
                },
                {
                    "name": "Communication",
                    "degree": "BA"
                },
                {
                    "name": "Comparative Literature and Cultural Studies",
                    "degree": "BA"
                },
                {
                    "name": "Criminology",
                    "degree": "BA"
                },
                {
                    "name": "Earth and Planetary Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Earth and Planetary Sciences",
                    "degree": "BS"
                },
                {
                    "name": "East Asian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "English Studies",
                    "degree": "BA"
                },
                {
                    "name": "English-Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Science",
                    "degree": "BS"
                },
                {
                    "name": "French",
                    "degree": "BA"
                },
                {
                    "name": "Geography",
                    "degree": "BA"
                },
                {
                    "name": "Geography",
                    "degree": "BS"
                },
                {
                    "name": "German",
                    "degree": "BA"
                },
                {
                    "name": "Health, Medicine and Human Values",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "International Studies",
                    "degree": "BA"
                },
                {
                    "name": "Journalism and Mass Communication",
                    "degree": "BA"
                },
                {
                    "name": "Languages",
                    "degree": "BA"
                },
                {
                    "name": "Latin American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Linguistics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Native American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Physics and Astrophysics",
                    "degree": "BA"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Portuguese",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Religious Studies",
                    "degree": "BA"
                },
                {
                    "name": "Russian",
                    "degree": "BA"
                },
                {
                    "name": "Signed Language Interpreting",
                    "degree": "BS"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Speech and Hearing Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Statistics",
                    "degree": "BS"
                },
                {
                    "name": "Women, Gender, and Sexuality Studies",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "College of Education and Human Sciences",
            "source": {
                "label": "UNM 2026-2027 Catalog, Programs",
                "url": "https://catalog.unm.edu/#/programs"
            },
            "majors": [
                {
                    "name": "Community Health Education",
                    "degree": "BS"
                },
                {
                    "name": "Elementary Education",
                    "degree": "BS in Education"
                },
                {
                    "name": "Exercise Science",
                    "degree": "BS"
                },
                {
                    "name": "Family and Child Studies",
                    "degree": "BS"
                },
                {
                    "name": "Nutrition and Dietetics",
                    "degree": "BS"
                },
                {
                    "name": "Physical Education",
                    "degree": "BS in Education"
                },
                {
                    "name": "Secondary Education",
                    "degree": "BA in Education"
                },
                {
                    "name": "Secondary Education",
                    "degree": "BS in Education"
                },
                {
                    "name": "Special Education and Elementary Education Dual License",
                    "degree": "BS in Education"
                }
            ]
        },
        {
            "name": "College of Fine Arts",
            "source": {
                "label": "UNM 2026-2027 Catalog, Programs",
                "url": "https://catalog.unm.edu/#/programs"
            },
            "majors": [
                {
                    "name": "Art Education",
                    "degree": "BA"
                },
                {
                    "name": "Art History",
                    "degree": "BA"
                },
                {
                    "name": "Art Studio",
                    "degree": "BA"
                },
                {
                    "name": "Art Studio",
                    "degree": "BFA"
                },
                {
                    "name": "Dance",
                    "degree": "BA"
                },
                {
                    "name": "Design and Technology for Performance",
                    "degree": "BFA"
                },
                {
                    "name": "Film and Digital Arts",
                    "degree": "BA"
                },
                {
                    "name": "Film and Digital Arts",
                    "degree": "BFA"
                },
                {
                    "name": "Interdisciplinary Arts",
                    "degree": "BA"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Music",
                    "degree": "BM"
                },
                {
                    "name": "Music Education",
                    "degree": "BME"
                },
                {
                    "name": "Theatre",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "College of Nursing",
            "source": {
                "label": "UNM 2026-2027 Catalog, Programs",
                "url": "https://catalog.unm.edu/#/programs"
            },
            "majors": [
                {
                    "name": "Nursing (Pre-Licensure B.S.N)",
                    "degree": "BS"
                },
                {
                    "name": "Nursing (R.N. to B.S.N.)",
                    "degree": "BS",
                    "note": "For students who are already registered nurses."
                }
            ]
        },
        {
            "name": "College of Pharmacy",
            "source": {
                "label": "UNM 2026-2027 Catalog, Programs",
                "url": "https://catalog.unm.edu/#/programs"
            },
            "majors": [
                {
                    "name": "Pharmaceutical Sciences",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Population Health",
            "source": {
                "label": "UNM 2026-2027 Catalog, Programs",
                "url": "https://catalog.unm.edu/#/programs"
            },
            "majors": [
                {
                    "name": "Population Health",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Honors College",
            "source": {
                "label": "UNM 2026-2027 Catalog, Programs",
                "url": "https://catalog.unm.edu/#/programs"
            },
            "majors": [
                {
                    "name": "Honors Interdisciplinary Liberal Arts",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "School of Architecture and Planning",
            "source": {
                "label": "UNM 2026-2027 Catalog, Programs",
                "url": "https://catalog.unm.edu/#/programs"
            },
            "majors": [
                {
                    "name": "Architecture",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Planning and Design",
                    "degree": "BA"
                },
                {
                    "name": "Landscape Architecture",
                    "degree": "BLA"
                }
            ]
        },
        {
            "name": "School of Engineering",
            "source": {
                "label": "UNM 2026-2027 Catalog, Programs",
                "url": "https://catalog.unm.edu/#/programs"
            },
            "majors": [
                {
                    "name": "Bioengineering",
                    "degree": "BS"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Construction Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Construction Management",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Nuclear Engineering",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "School of Medicine",
            "source": {
                "label": "UNM 2026-2027 Catalog, Programs",
                "url": "https://catalog.unm.edu/#/programs"
            },
            "majors": [
                {
                    "name": "Dental Hygiene",
                    "degree": "BS"
                },
                {
                    "name": "Emergency Medical Services",
                    "degree": "BS"
                },
                {
                    "name": "Medical Laboratory Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Radiologic Sciences",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "The James and Gail Ellis School of Business Leadership",
            "source": {
                "label": "UNM 2026-2027 Catalog, Programs",
                "url": "https://catalog.unm.edu/#/programs"
            },
            "majors": [
                {
                    "name": "Business Administration",
                    "degree": "BBA"
                }
            ]
        },
        {
            "name": "University College",
            "source": {
                "label": "UNM 2026-2027 Catalog, Programs",
                "url": "https://catalog.unm.edu/#/programs"
            },
            "majors": [
                {
                    "name": "Liberal Arts and Integrative Studies",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "University Libraries and Learning Sciences",
            "source": {
                "label": "UNM 2026-2027 Catalog, Programs",
                "url": "https://catalog.unm.edu/#/programs"
            },
            "majors": [
                {
                    "name": "Instructional Technology and Training",
                    "degree": "BS"
                }
            ]
        }
    ]
};

export default majors;
